import React from 'react';
import { motion } from 'framer-motion';
import { Route } from 'react-router-dom';

const PublicRoute = ({ component: Component, ...rest }) => {

  return (
    // Show the component only when the admin is logged in
    // Otherwise, redirect the admin to /signin page
    <Route
      {...rest}
      render={(props) =>
          <motion.div initial={{ x: 200 }} animate={{ x: 0 }} exit={{ scale: 0 }}>
            <Component {...props} />
          </motion.div>
      }
    />
  );
};

export default PublicRoute;
